import { createContext, useContext } from 'react';

import { Locale, ShopBundle } from '../types';

type AppContextData = {
  shopBundle: ShopBundle;
  domain: string;
  locale: Locale;
  csrfToken?: string;
};

// Provided default values are only there for typescript to be happy.
// They will never be used.
const AppContext = createContext<AppContextData>({
  shopBundle: 'zooplus',
  domain: 'zooplus.com',
  locale: 'zu',
  csrfToken: undefined,
});

export const useAppContext = () => useContext(AppContext);

export default AppContext.Provider;
